<template>
  <v-card class="profile-container" flat>
    <v-tabs>
      <v-tab ripple>
        Conta
      </v-tab>
      <v-tab ripple>
        Empresa
      </v-tab>
      <v-tab ripple>
        Pessoal
      </v-tab>
      <v-tab ripple>
        Endereço
      </v-tab>

      <v-tab-item>
        <data-account />
      </v-tab-item>

      <v-tab-item>
        <data-company />
      </v-tab-item>

      <v-tab-item>
        <data-personal />
      </v-tab-item>

      <v-tab-item>
        <data-address />
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import DataAccount from '@/components/account/profile/DataAccount';
import DataPersonal from '@/components/account/profile/DataPersonal';
import DataCompany from '@/components/account/profile/DataCompany';
import DataAddress from '@/components/account/profile/DataAddress';

export default {
  name: 'Profile',
  components: {
    DataAccount,
    DataPersonal,
    DataCompany,
    DataAddress,
  },
  mounted() {
    this.getProfile();
  },
  // data() {
  //   return {
  //     updateSuccessMessage: '',
  //     updateFailedMessage: '',
  //   };
  // },
  methods: {
    getProfile() {
      this.$store.dispatch('getUser');
    },
    // updateProfile(id, body) {
    //   profileService.updateProfile(id, body)
    //     .then((response) => {
    //       this.$store.dispatch('setUser', response.data);
    //     })
    //     .catch((error) => {
    //       this.updateFailedMessage = error.response;
    //     });
    // },
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
};
</script>

<style scoped lang="scss">
  .profile-container {
    height: calc(100vh - 96px);
  }
</style>



// WEBPACK FOOTER //
// src/views/account/profile/FormProfile.vue